import type { LocationDescriptor } from 'history';
import type { HTMLAttributes } from 'react';

export type CardItemBreedQuizResultAttributeType =
  | 'exercise'
  | 'education'
  | 'care'
  | 'sociability';

export interface CardItemBreedQuizResultData {
  name?: string;
  translatedName?: string;
  image?: string;
  attributes?: Record<CardItemBreedQuizResultAttributeType, number>;
  matchPercentage?: number;
  infoLink?: LocationDescriptor;
  littersLink?: LocationDescriptor;
  breedersLink?: LocationDescriptor;
  isSubscribed: boolean;

  onSubscribeClick(): void;
}

export interface CardItemBreedQuizResultProps
  extends HTMLAttributes<HTMLDivElement>,
    CardItemBreedQuizResultData {}
